"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var to_string_1 = require("./to-string");
var lowerCase = function (str) {
    return to_string_1.default(str).toLowerCase();
};
exports.default = lowerCase;
//# sourceMappingURL=lower-case.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/lower-case.js
// module id = 1129
// module chunks = 37